var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import { BLOCK, BTN, INVERSE, OUTLINE, SM, SOLID } from '../../constants';
import classes from '../../utils/classes';
import cssJoin from '../../utils/cssJoin';
import cssPrefix from '../../utils/cssPrefix';
import withMemoRef from '../../utils/withMemoRef';
import Spinner from '../Spinner';
/**
 * Button prefix.
 */
const buttonPrefix = cssPrefix(BTN);
/**
 * Button component.
 *
 * @param props Button properties.
 */
export const Button = withMemoRef('Button', (_a, ref) => {
  var {
      block = false,
      children,
      className,
      disabled = false,
      family = SOLID,
      inverse = false,
      loading = false,
      plain = false,
      purpose,
      small = false,
      type = 'button'
    } = _a,
    props = __rest(_a, [
      'block',
      'children',
      'className',
      'disabled',
      'family',
      'inverse',
      'loading',
      'plain',
      'purpose',
      'small',
      'type'
    ]);
  return React.createElement(
    'button',
    Object.assign(
      {
        className: classes(
          {
            [BTN]: !plain,
            [buttonPrefix(
              family === OUTLINE
                ? cssJoin(purpose, OUTLINE)
                : purpose !== null && purpose !== void 0
                ? purpose
                : ''
            )]: purpose,
            [buttonPrefix(BLOCK)]: block,
            [buttonPrefix(family)]: family !== SOLID,
            [buttonPrefix(INVERSE)]: inverse,
            [buttonPrefix(SM)]: small
          },
          className
        ),
        disabled: disabled || loading,
        role: 'button',
        type: type
      },
      Object.assign(Object.assign({}, props), { ref })
    ),
    loading ? React.createElement(Spinner, { inline: true }) : children
  );
});
export default Button;
